import { MutableRefObject, useEffect, useRef, useState } from 'react'

import { Position } from 'lib/_types'

type Props = {
  threshold?: number
  target?: MutableRefObject<HTMLDivElement>
}

export const useScroll = ({ threshold = 20, target }: Props = {}) => {
  const startTimeRef = useRef(0)
  const [startPosition, setStartPosition] = useState<Position>({ x: 0, y: 0 })
  const [position, setPosition] = useState<Position>({ x: 0, y: 0 })
  const [diff, setDiff] = useState<Position>({ x: 0, y: 0 })

  useEffect(() => {
    const callback = (e: Event) => {
      const current: Position = {
        x: target?.current?.scrollLeft ?? window.scrollX,
        y: target?.current?.scrollTop ?? window.scrollY,
      }

      if (!startTimeRef.current) {
        startTimeRef.current = e.timeStamp
        setStartPosition(current)
      }
      setPosition(current)
    }

    const eventTarget = target?.current ?? window
    eventTarget.addEventListener('scroll', callback)

    return () => {
      eventTarget.removeEventListener('scroll', callback)
    }
  }, [target])

  useEffect(() => {
    const diff: Position = {
      x: position.x - startPosition.x,
      y: position.y - startPosition.y,
    }

    const timeout = setTimeout(() => {
      startTimeRef.current = 0
      if (Math.abs(diff.x) >= threshold || Math.abs(diff.y) >= threshold) {
        setDiff(diff)
      }
    }, 500)

    return () => {
      clearTimeout(timeout)
    }
  }, [threshold, position])

  return {
    diff,
    position,
    scrolling: !!startTimeRef.current,
  }
}
